<template>
  <step-wrapper space-between>
    <step-header :text="text" step="2" step-count="4" strong/>
    <content-wrapper>
      <textarea-input
        v-model="place.description"
        placeholder="Opis miejsca..."
        :required="true"
        hint="max 1000. znaków"
      />
    </content-wrapper>
    <content-wrapper type="small">
      <button-component
        :disabled="isButtonDisabled"
        fixed-width
        @click="goToNextStep"
      >
        Dalej
      </button-component>
    </content-wrapper>
  </step-wrapper>
</template>

<script>
import store from '@/store'
import {mapState} from 'vuex'
import StepWrapper from '@/components/StepWrapper'
import ContentWrapper from '@/components/ContentWrapper'
import StepHeader from '@/components/StepHeader'
import TextareaInput from '@/components/TextareaInput'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    StepWrapper,
    StepHeader,
    ContentWrapper,
    TextareaInput,
    ButtonComponent
  },
  data () {
    return {
      text: `
        Opisz to miejsce<br>najlepiej jak potrafisz
      `
    }
  },
  beforeRouteEnter (to, from, next) {
    const currentStep = store.getters.currentAddPlaceStep
    if (currentStep > 1) {
      next()
    } else {
      next({ name: `add-step-${ currentStep }` })
    }
  },
  computed: {
    ...mapState({
      place: state => state.add.place
    }),
    isButtonDisabled () {
      return !this.place.description
    }
  },
  methods: {
    goToNextStep () {
      this.$router.push({ name: 'add-step-3' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/AddPlace/AddSecondStep.vue